import { Building2 } from "lucide-react";

/** Two-letter initials for an avatar placeholder. */
export function initials(name: string): string {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

/** Circular team avatar. */
export function TeamIcon() {
  return (
    <div className="w-8 h-8 bg-linear-to-br from-brand-primary/30 to-brand-secondary/30 rounded-full flex items-center justify-center shrink-0">
      <Building2 className="w-4 h-4 text-brand-primary" />
    </div>
  );
}

/** Circular user avatar with initials. */
export function UserIcon({ name }: Readonly<{ name: string }>) {
  return (
    <div className="w-8 h-8 bg-linear-to-br from-slate-600 to-slate-700 rounded-full flex items-center justify-center shrink-0">
      <span className="text-xs font-bold text-white">{initials(name)}</span>
    </div>
  );
}
